import { useState } from 'react';
import { useRouter } from 'next/router';

import { accountsApi } from 'api/accountsApi';

import { useAdDetailsContext } from 'contexts/AdDetailsContext';

import { fireToast } from 'helpers/Toasts';
import { rg4js } from 'helpers/raygun';
import { PAGE } from 'helpers/pages';
import { pushToDataLayer } from 'services/gtmService';

const useContactDealershipBottomSheet = (args: { adId: number }) => {
  const { adId } = args;

  const { push } = useRouter();

  const { isContactSellerModalOpen, setIsContactSellerModalOpen } =
    useAdDetailsContext();

  const [isLoading, setIsLoading] = useState(false);

  // TODO: replace with mutation
  const onWhatsAppButtonClick = async () => {
    pushToDataLayer({ event: 'whatsapp_click' });
    setIsLoading(true);
    try {
      const {
        data: { url },
      } = await accountsApi.getWhatsAppLink(adId);
      push(url);
    } catch (error) {
      rg4js('send', {
        error,
        customData: {
          pageName: PAGE.AD_DETAILS,
          functionName: 'onWhatsAppButtonClick',
        },
      });
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
    setIsLoading(false);
  };

  const closeContactSellerModal = () => setIsContactSellerModalOpen(false);

  return {
    isContactSellerModalOpen,
    onWhatsAppButtonClick,
    isLoading,
    closeContactSellerModal,
  };
};

export { useContactDealershipBottomSheet };
